export enum NotificationColorByType {
  SUCCESS = 'green',
  DANGER = 'red',
  WARNING = 'orange',
}
